/*
 * @Description: CoatingForLenses组件 - 展示镜片涂层信息
 * 从Vue组件转换而来，支持响应式设计
 */
'use client';

import Image from '@/components/Image';
import React from 'react';

// 定义数据项的类型
interface CoatingForLensesItem {
  image: string;
  title: string;
}

// 定义组件props的类型
interface CoatingForLensesData {
  title: string;
  data_array: CoatingForLensesItem[];
}

interface CoatingForLensesProps {
  coatingForLensesData: CoatingForLensesData;
}

/**
 * CoatingForLenses组件 - 展示镜片涂层信息
 * @param coatingForLensesData - 包含涂层数据的对象
 */
const CoatingForLenses: React.FC<CoatingForLensesProps> = ({ coatingForLensesData }) => {
  // 如果没有数据，不渲染组件
  if (!coatingForLensesData?.data_array?.length) {
    return null;
  }

  return (
    <div className="bg-[#F4F4F4] pt-32 md:pt-0 pb-32 md:pb-0 md:bg-white  w-full px-[240px] xl:px-[240px] lg:px-[160px] md:px-[120px] sm:px-[60px] max-sm:px-[24px] box-border my-[104px] xl:my-[104px] lg:my-[80px] md:my-[60px] sm:my-[40px] max-sm:my-[32px] mb-[120px] xl:mb-[120px] lg:mb-[96px] md:mb-[80px] sm:mb-[60px] max-sm:mb-[48px]">
      <h2 className="text-[24px] md:text-[40px] lg:text-[32px] sm:text-[24px] max-sm:text-[28px] font-bb text-center mb-[40px] xl:mb-[40px] lg:mb-[32px] md:mb-[24px] sm:mb-[20px] max-sm:mb-[24px]">
        {coatingForLensesData.title}
      </h2>

      <ul className="grid grid-cols-2 md:grid-cols-4 gap-[24px]">
        {coatingForLensesData.data_array.map((item, index) => (
          <li
            key={index}
            className="flex flex-col items-center justify-start max-sm:w-full rounded-[12px] xl:rounded-[12px] lg:rounded-[10px] md:rounded-[8px] sm:rounded-[6px] max-sm:rounded-[8px] bg-[#F4F4F4] px-[24px] xl:px-[24px] lg:px-[20px] md:px-[16px] sm:px-[12px] max-sm:px-[16px] box-border"
          >
            <Image
              src={item.image}
              alt={item.title.replace(/<[^>]*>/g, '')} // 移除HTML标签作为alt
              width={82}
              height={82}
              className="md:w-[82px] w-[46px] h-auto block mb-[20px] xl:mb-[20px] lg:mb-[16px] md:mb-[12px] sm:mb-[10px] max-sm:mb-[12px]"
            />
            <h4
              className="text-[13px] xl:text-[20px] lg:text-[18px] md:text-[16px] sm:text-[14px] max-sm:text-[16px] leading-[30px] xl:leading-[30px] lg:leading-[27px] md:leading-[24px] sm:leading-[21px] max-sm:leading-[24px] font-bb text-center whitespace-nowrap"
              dangerouslySetInnerHTML={{ __html: item.title }}
            />
          </li>
        ))}
      </ul>
    </div>
  );
};

export default CoatingForLenses;
